import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FileStorageService } from '../file-storage-service';

/**
 * 内存文件存储服务实现
 * 用于在上传和识别阶段之间缓存文件
 */
@injectable()
export class MemoryFileStorageService implements FileStorageService {
    private readonly _fileCache = new Map<string, File>();

    /**
     * 存储文件
     */
    storeFile(fileId: string, file: File): void {
        this._fileCache.set(fileId, file);
    }

    /**
     * 获取存储的文件
     */
    getFile(fileId: string): File | undefined {
        return this._fileCache.get(fileId);
    }

    /**
     * 移除存储的文件
     */
    removeFile(fileId: string): void {
        this._fileCache.delete(fileId);
    }

    /**
     * 清除所有存储的文件
     */
    clear(): void {
        this._fileCache.clear();
    }

    /**
     * 获取存储的文件数量
     */
    size(): number {
        return this._fileCache.size;
    }
}
